var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "saas-page linear-page" }, [
    _c("section", { staticClass: "linear-hero" }, [
      _c("div", [
        _c(
          "p",
          { staticClass: "linear-kicker" },
          [
            _c("router-link", { attrs: { to: "/home" } }, [
              _vm._v(_vm._s(_vm.trans("general.home"))),
            ]),
            _vm._v(" "),
            _c("span", [_vm._v("/")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.trans("user.profile")))]),
          ],
          1
        ),
        _vm._v(" "),
        _c("h1", [_vm._v(_vm._s(_vm.trans("user.profile")))]),
        _vm._v(" "),
        _c("p", { staticClass: "linear-copy" }, [
          _vm._v(
            "Keep administrator identity, personal details, and public profile links current."
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "linear-command-card" }, [
        _c("span", { staticClass: "linear-dot" }),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.trans("user.update_profile")))]),
        _vm._v(" "),
        _c("kbd", [_vm._v(_vm._s(_vm.trans("general.save")))]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "linear-grid" }, [
      _c("section", { staticClass: "linear-card linear-card--wide" }, [
        _c("div", { staticClass: "linear-card__head" }, [
          _c("div", [
            _c("span", { staticClass: "linear-label" }, [
              _vm._v(_vm._s(_vm.trans("user.profile"))),
            ]),
            _vm._v(" "),
            _c("h2", [_vm._v(_vm._s(_vm.trans("user.update_profile")))]),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "linear-status" }, [
            _vm._v(_vm._s(_vm.trans("general.save"))),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "form",
          {
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.updateProfile.apply(null, arguments)
              },
              keydown: function ($event) {
                return _vm.profileForm.errors.clear($event.target.name)
              },
            },
          },
          [
            _c("div", { staticClass: "linear-form-grid" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", [_vm._v(_vm._s(_vm.trans("user.first_name")))]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.profileForm.first_name,
                        expression: "profileForm.first_name",
                      },
                    ],
                    staticClass: "form-control linear-input",
                    attrs: { type: "text", name: "first_name" },
                    domProps: { value: _vm.profileForm.first_name },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.profileForm,
                          "first_name",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("show-error", {
                    attrs: {
                      "form-name": _vm.profileForm,
                      "prop-name": "first_name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", [_vm._v(_vm._s(_vm.trans("user.last_name")))]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.profileForm.last_name,
                        expression: "profileForm.last_name",
                      },
                    ],
                    staticClass: "form-control linear-input",
                    attrs: { type: "text", name: "last_name" },
                    domProps: { value: _vm.profileForm.last_name },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.profileForm,
                          "last_name",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("show-error", {
                    attrs: {
                      "form-name": _vm.profileForm,
                      "prop-name": "last_name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", [
                    _vm._v(_vm._s(_vm.trans("user.date_of_birth"))),
                  ]),
                  _vm._v(" "),
                  _c("datepicker", {
                    attrs: { bootstrapStyling: true, name: "date_of_birth" },
                    on: {
                      selected: function ($event) {
                        return _vm.profileForm.errors.clear("date_of_birth")
                      },
                    },
                    model: {
                      value: _vm.profileForm.date_of_birth,
                      callback: function ($$v) {
                        _vm.$set(_vm.profileForm, "date_of_birth", $$v)
                      },
                      expression: "profileForm.date_of_birth",
                    },
                  }),
                  _vm._v(" "),
                  _c("show-error", {
                    attrs: {
                      "form-name": _vm.profileForm,
                      "prop-name": "date_of_birth",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", [
                    _vm._v(_vm._s(_vm.trans("user.date_of_anniversary"))),
                  ]),
                  _vm._v(" "),
                  _c("datepicker", {
                    attrs: {
                      bootstrapStyling: true,
                      name: "date_of_anniversary",
                    },
                    on: {
                      selected: function ($event) {
                        return _vm.profileForm.errors.clear(
                          "date_of_anniversary"
                        )
                      },
                    },
                    model: {
                      value: _vm.profileForm.date_of_anniversary,
                      callback: function ($$v) {
                        _vm.$set(_vm.profileForm, "date_of_anniversary", $$v)
                      },
                      expression: "profileForm.date_of_anniversary",
                    },
                  }),
                  _vm._v(" "),
                  _c("show-error", {
                    attrs: {
                      "form-name": _vm.profileForm,
                      "prop-name": "date_of_anniversary",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "linear-section" },
              [
                _c("label", [_vm._v(_vm._s(_vm.trans("user.gender")))]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "linear-radio-list" },
                  _vm._l(_vm.genders, function (gender) {
                    return _c(
                      "label",
                      {
                        key: gender.id,
                        staticClass: "linear-radio",
                        attrs: { for: "profile-gender-" + gender.id },
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.profileForm.gender,
                              expression: "profileForm.gender",
                            },
                          ],
                          attrs: {
                            type: "radio",
                            id: "profile-gender-" + gender.id,
                            name: "gender",
                          },
                          domProps: {
                            value: gender.id,
                            checked: _vm.profileForm.gender == gender.id,
                            checked: _vm._q(_vm.profileForm.gender, gender.id),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.profileForm.errors.clear("gender")
                            },
                            change: function ($event) {
                              return _vm.$set(
                                _vm.profileForm,
                                "gender",
                                gender.id
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.trans("list." + gender.id))),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("show-error", {
                  attrs: {
                    "form-name": _vm.profileForm,
                    "prop-name": "gender",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "linear-section" }, [
              _c(
                "div",
                { staticClass: "linear-card__head linear-card__head--sub" },
                [
                  _c("div", [
                    _c("span", { staticClass: "linear-label" }, [
                      _vm._v("Social"),
                    ]),
                    _vm._v(" "),
                    _c("h2", [_vm._v(_vm._s(_vm.trans("user.profile")))]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "linear-form-grid" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [
                      _vm._v(
                        _vm._s(
                          _vm.trans("user.sm_profile", { name: "Facebook" })
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.profileForm.facebook_profile,
                          expression: "profileForm.facebook_profile",
                        },
                      ],
                      staticClass: "form-control linear-input",
                      attrs: { type: "text", name: "facebook_profile" },
                      domProps: { value: _vm.profileForm.facebook_profile },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.profileForm,
                            "facebook_profile",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("show-error", {
                      attrs: {
                        "form-name": _vm.profileForm,
                        "prop-name": "facebook_profile",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [
                      _vm._v(
                        _vm._s(
                          _vm.trans("user.sm_profile", { name: "Twitter" })
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.profileForm.twitter_profile,
                          expression: "profileForm.twitter_profile",
                        },
                      ],
                      staticClass: "form-control linear-input",
                      attrs: { type: "text", name: "twitter_profile" },
                      domProps: { value: _vm.profileForm.twitter_profile },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.profileForm,
                            "twitter_profile",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("show-error", {
                      attrs: {
                        "form-name": _vm.profileForm,
                        "prop-name": "twitter_profile",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [
                      _vm._v(
                        _vm._s(
                          _vm.trans("user.sm_profile", { name: "Google Plus" })
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.profileForm.google_plus_profile,
                          expression: "profileForm.google_plus_profile",
                        },
                      ],
                      staticClass: "form-control linear-input",
                      attrs: { type: "text", name: "google_plus_profile" },
                      domProps: { value: _vm.profileForm.google_plus_profile },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.profileForm,
                            "google_plus_profile",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("show-error", {
                      attrs: {
                        "form-name": _vm.profileForm,
                        "prop-name": "google_plus_profile",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [
                      _vm._v(
                        _vm._s(
                          _vm.trans("user.sm_profile", { name: "Linkedin" })
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.profileForm.linkedin_profile,
                          expression: "profileForm.linkedin_profile",
                        },
                      ],
                      staticClass: "form-control linear-input",
                      attrs: { type: "text", name: "linkedin_profile" },
                      domProps: { value: _vm.profileForm.linkedin_profile },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.profileForm,
                            "linkedin_profile",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("show-error", {
                      attrs: {
                        "form-name": _vm.profileForm,
                        "prop-name": "linkedin_profile",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "linear-actions" }, [
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
                  attrs: { type: "submit" },
                },
                [_vm._v(_vm._s(_vm.trans("general.save")))]
              ),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("aside", { staticClass: "linear-card linear-avatar-card" }, [
        _c("div", { staticClass: "linear-card__head text-center" }, [
          _c("div", [
            _c("span", { staticClass: "linear-label" }, [
              _vm._v(_vm._s(_vm.trans("user.profile"))),
            ]),
            _vm._v(" "),
            _c("h2", [_vm._v(_vm._s(_vm.trans("user.avatar")))]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "linear-avatar-shell" },
          [
            _c("upload-image", {
              attrs: {
                id: "avatar",
                presentation: "avatar",
                "upload-path": `/user/profile/avatar/${_vm.getAuthUser("id")}`,
                "remove-path": `/user/profile/avatar/remove/${_vm.getAuthUser(
                  "id"
                )}`,
                "image-source": _vm.avatar.user,
              },
              on: { uploaded: _vm.updateAvatar, removed: _vm.updateAvatar },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }